import { getBrowserDimensions } from "./layout";
import { initOverlayLinks } from "./overlay";
import debounce from "lodash/debounce";
import { tns } from "tiny-slider/src/tiny-slider";

// Set siema items per page object
const printSlideIndex = (carousel) => {
  carousel.innerElements.forEach((slide, i) => {
    const addOrRemove = i === carousel.currentSlide ? "add" : "remove";
    carousel.innerElements[i].classList[addOrRemove]("current");
  });
};

const setCarouselActiveClass = (slider) => {
  const info = slider.getInfo();
  const indexPrev = info.indexCached;
  const indexCurrent = info.index;
  // make ALL not current
  const itemsArray = Array.from(info.slideItems);
  itemsArray.forEach((element) => {
    element.classList.remove("current");
  });
  // set current
  info.slideItems[indexCurrent].classList.add("current");
  // console.log('tns index:'+indexCurrent);
};

const manageSlideHeights = (carousel) => {
  // set highestSlide to 0
  let highestSlide = 0;
  // find highest slide
  carousel.innerElements.forEach((slide, i) => {
    // clear any set style
    carousel.innerElements[i].removeAttribute("style");
    // set highestSlide to this if this is higher
    if (carousel.innerElements[i].clientHeight > highestSlide) {
      highestSlide = carousel.innerElements[i].clientHeight;
    }
  });
  // set all slides to highest
  carousel.innerElements.forEach((slide, i) => {
    carousel.innerElements[i].style.height = highestSlide + "px";
  });
};

const manageTnsSlideHeights = (carousel) => {
  // get carousel info
  const info = carousel.getInfo();
  // set highestSlide to 0
  let highestSlide = 0;
  // find highest slide
  const carouselElements = Array.from(info.slideItems);
  carouselElements.forEach((slide, i) => {
    // clear any set style
    carouselElements[i].removeAttribute("style");
    // set highestSlide to this if this is higher
    if (carouselElements[i].clientHeight > highestSlide) {
      highestSlide = carouselElements[i].clientHeight;
    }
  });
  // set all slides to highest
  carouselElements.forEach((slide, i) => {
    carouselElements[i].firstChild.style.height = highestSlide + "px";
  });
};

// determine if carousel loops
const carouselLoop = (reqCarousel, itemsObject) => {
  // loop is false by default
  let loop = false;
  // get page items depending on browser width
  let carouselItems = 1;
  // check each property in items object
  for (var size in itemsObject) {
    // if browser width is over property size, use the property item number
    if (getBrowserDimensions("width") >= size) {
      carouselItems = itemsObject[size];
    }
  }
  // get items count
  const carouselItemsArray = Array.from(
    reqCarousel.querySelectorAll(".carousel__item")
  );
  // if more items than page items, loop
  if (carouselItemsArray.length > carouselItems) {
    loop = true;
  }
  return loop;
};

// Set instagram carousel
let homeInstagramCarousel;
const instagramCarousel = document.getElementById("instagram-carousel");
if (instagramCarousel) {
  const carouselLocation = instagramCarousel.dataset.location;
  let responsiveObject;
  if (carouselLocation == "home") {
    responsiveObject = {
      0: {
        edgePadding: 47.5,
        items: 1,
      },
      420: {
        edgePadding: 50,
        items: parseInt(instagramCarousel.dataset.items420),
      },
      768: {
        edgePadding: 100,
        items: parseInt(instagramCarousel.dataset.items768),
      },
      1280: {
        edgePadding: 130,
      },
    };
  }
  if (carouselLocation == "exhibition") {
    responsiveObject = {
      0: {
        edgePadding: 47.5,
        items: 1,
      },
      420: {
        edgePadding: 0,
        items: parseInt(instagramCarousel.dataset.items420),
      },
      768: {
        edgePadding: 0,
        items: parseInt(instagramCarousel.dataset.items768),
      },
      1280: {
        edgePadding: 0,
      },
    };
  }

  homeInstagramCarousel = tns({
    container: "#instagram-carousel",
    startIndex: 0,
    mouseDrag: true,
    speed: 200,
    loop: true,
    gutter: 20,
    controls: false,
    nav: false,
    responsive: responsiveObject,
  });

  const instagramCarouselPrev = document.getElementById(
    "instagram-carousel__prev"
  );
  const instagramCarouselNext = document.getElementById(
    "instagram-carousel__next"
  );
  if (instagramCarouselPrev && instagramCarouselNext) {
    instagramCarouselPrev.addEventListener("click", () =>
      homeInstagramCarousel.goTo("prev")
    );
    instagramCarouselNext.addEventListener("click", () =>
      homeInstagramCarousel.goTo("next")
    );
  }
}

// Set exhibit highlights carousel
let exhibitHighlightsCarousel;
const highlightsCarousel = document.getElementById("highlights__carousel");
if (highlightsCarousel) {
  exhibitHighlightsCarousel = tns({
    container: "#highlights__carousel",
    startIndex: 0,
    mouseDrag: true,
    speed: 200,
    loop: true,
    controls: false,
    nav: false,
    responsive: {
      0: {
        edgePadding: 45,
        items: 1,
        gutter: 20,
      },
      480: {
        edgePadding: 0,
        items: 1,
        gutter: 0,
      },
    },
    onInit: () => { },
  });
  // set initial index
  setCarouselActiveClass(exhibitHighlightsCarousel);
  // se index on change
  exhibitHighlightsCarousel.events.on("indexChanged", () => {
    setCarouselActiveClass(exhibitHighlightsCarousel);
  });
  const highlightsCarouselPrev = document.getElementById(
    "highlights__carousel-prev"
  );
  const highlightsCarouselNext = document.getElementById(
    "highlights__carousel-next"
  );
  if (highlightsCarouselPrev && highlightsCarouselNext) {
    highlightsCarouselPrev.addEventListener("click", () =>
      exhibitHighlightsCarousel.goTo("prev")
    );
    highlightsCarouselNext.addEventListener("click", () =>
      exhibitHighlightsCarousel.goTo("next")
    );
  }
  const highlightsCarouselPrev2 = document.getElementById(
    "highlights__carousel-prev-2"
  );
  const highlightsCarouselNext2 = document.getElementById(
    "highlights__carousel-next-2"
  );
  if(highlightsCarouselPrev2 && highlightsCarouselNext2){
    highlightsCarouselPrev2.addEventListener("click", () =>
      exhibitHighlightsCarousel.goTo("prev")
    );
    highlightsCarouselNext2.addEventListener("click", () =>
      exhibitHighlightsCarousel.goTo("next")
    );    
  }
}

// Set discover carousel
let exhibitDiscoverCarousel;
const discoverCarousel = document.getElementById("discover__carousel");
if (discoverCarousel) {
  exhibitDiscoverCarousel = tns({
    container: "#discover__carousel",
    startIndex: 0,
    mouseDrag: true,
    speed: 200,
    loop: true,
    gutter: 20,
    controls: false,
    nav: false,
    responsive: {
      0: {
        edgePadding: 45,
        items: 1,
      },
      480: {
        edgePadding: 0,
        items: 3,
      },
      768: {
        items: 4,
      },
    },
  });
  // setup slider overlay links
  initOverlayLinks();
  // set initial index
  setCarouselActiveClass(exhibitDiscoverCarousel);
  // se index on change
  exhibitDiscoverCarousel.events.on("indexChanged", () => {
    setCarouselActiveClass(exhibitDiscoverCarousel);
  });

  const discoverCarouselPrev = document.getElementById(
    "discover__carousel-prev"
  );
  const discoverCarouselNext = document.getElementById(
    "discover__carousel-next"
  );
  if (discoverCarouselPrev && discoverCarouselNext) {
    discoverCarouselPrev.addEventListener("click", () =>
      exhibitDiscoverCarousel.goTo("prev")
    );
    discoverCarouselNext.addEventListener("click", () =>
      exhibitDiscoverCarousel.goTo("next")
    );
  }
}

// set featured items carousel featured_items carousel
const featuredItemsCarousel = Array.from(
  document.querySelectorAll(".featured_items-carousel")
);
if (featuredItemsCarousel.length > 0) {
  featuredItemsCarousel.forEach((element) => {
    let thisCarousel;
    const thisCarouselNode = element;
    const thisCarouselNodeId = thisCarouselNode.getAttribute("id");

    thisCarousel = tns({
      container: thisCarouselNode,
      startIndex: 0,
      mouseDrag: true,
      speed: 200,
      loop: true,
      gutter: 20,
      controls: false,
      nav: false,
      responsive: {
        0: {
          edgePadding: 45,
          items: 1,
        },
        480: {
          edgePadding: 0,
          items: 3,
        },
        768: {
          items: 4,
        },
      },
    });

    // setup slider overlay links
    initOverlayLinks();
    // set initial index
    setCarouselActiveClass(thisCarousel);
    // se index on change
    thisCarousel.events.on("indexChanged", () => {
      setCarouselActiveClass(thisCarousel);
    });
    const thisCarouselPrev = document.getElementById(
      thisCarouselNodeId + "--prev"
    );
    const thisCarouselNext = document.getElementById(
      thisCarouselNodeId + "--next"
    );
    if (thisCarouselPrev && thisCarouselNext) {
      thisCarouselPrev.addEventListener("click", () =>
        thisCarousel.goTo("prev")
      );
      thisCarouselNext.addEventListener("click", () =>
        thisCarousel.goTo("next")
      );
    }
  });
}

// Set press carousel
let exhibitPressCarousel;
const pressCarousel = document.getElementById("press__carousel");
if (pressCarousel) {
  const initPressCarousel = () => {
    exhibitPressCarousel = tns({
      container: "#press__carousel",
      startIndex: 0,
      mouseDrag: true,
      speed: 200,
      loop: true,
      gutter: 0,
      controls: false,
      nav: false,
      responsive: {
        0: {
          items: 1,
        },
        480: {
          items: 2,
        },
        768: {
          items: 3,
        },
      },
    });
    manageTnsSlideHeights(exhibitPressCarousel);
    const pressCarouselPrev = document.getElementById("press__carousel-prev");
    const pressCarouselNext = document.getElementById("press__carousel-next");
    if (pressCarouselPrev && pressCarouselNext) {
      pressCarouselPrev.addEventListener("click", () =>
        exhibitPressCarousel.goTo("prev")
      );
      pressCarouselNext.addEventListener("click", () =>
        exhibitPressCarousel.goTo("next")
      );
    }
  };
  initPressCarousel();
  window.addEventListener(
    "resize",
    debounce(() => {
      exhibitPressCarousel.destroy();
      initPressCarousel();
    }, 150)
  );
}

// Set exhibition events carousel
let exhibitEventsCarousel;
const eventsCarousel = document.getElementById("events__carousel");
if (eventsCarousel) {
  exhibitEventsCarousel = tns({
    container: "#events__carousel",
    startIndex: 0,
    mouseDrag: true,
    speed: 200,
    loop: true,
    gutter: 20,
    controls: false,
    nav: false,
    responsive: {
      0: {
        edgePadding: 45,
        items: 1,
      },
      480: {
        edgePadding: 0,
        items: 3,
      },
      768: {
        items: 4,
      },
    },
  });
  // setup slider overlay links
  initOverlayLinks();
  // set initial index
  setCarouselActiveClass(exhibitEventsCarousel);
  // se index on change
  exhibitEventsCarousel.events.on("indexChanged", () => {
    setCarouselActiveClass(exhibitEventsCarousel);
  });
  const eventsCarouselPrev = document.getElementById("events__carousel-prev");
  const eventsCarouselNext = document.getElementById("events__carousel-next");
  if (eventsCarouselPrev && eventsCarouselNext) {
    eventsCarouselPrev.addEventListener("click", () =>
      exhibitEventsCarousel.goTo("prev")
    );
    eventsCarouselNext.addEventListener("click", () =>
      exhibitEventsCarousel.goTo("next")
    );
  }
}

// Set exhibition events carousel
let exhibitPastEventsCarousel;
const pastEventsCarousel = document.getElementById("past_events__carousel");
if (pastEventsCarousel) {
  exhibitPastEventsCarousel = tns({
    container: "#past_events__carousel",
    startIndex: 0,
    mouseDrag: true,
    speed: 200,
    loop: true,
    gutter: 20,
    controls: false,
    nav: false,
    responsive: {
      0: {
        edgePadding: 45,
        items: 1,
      },
      480: {
        edgePadding: 0,
        items: 3,
      },
      768: {
        items: 4,
      },
    },
  });
  // setup slider overlay links
  initOverlayLinks();
  // set initial index
  setCarouselActiveClass(exhibitPastEventsCarousel);
  // se index on change
  exhibitPastEventsCarousel.events.on("indexChanged", () => {
    setCarouselActiveClass(exhibitPastEventsCarousel);
  });
  const eventsCarouselPrev = document.getElementById("past_events__carousel-prev");
  const eventsCarouselNext = document.getElementById("past_events__carousel-next");
  if (eventsCarouselPrev && eventsCarouselNext) {
    eventsCarouselPrev.addEventListener("click", () =>
      exhibitPastEventsCarousel.goTo("prev")
    );
    eventsCarouselNext.addEventListener("click", () =>
      exhibitPastEventsCarousel.goTo("next")
    );
  }
}

// set Image Slider
const imageSliders = document.querySelectorAll(".image-slider");
if (imageSliders) {
  const imageSlidersArray = Array.from(imageSliders);
  imageSlidersArray.forEach((slider) => {
    let imageSlidersCarousel;
    const slideId = slider.getAttribute("id");
    const sliderItems = slider.dataset.items;
    const selectorName = "#" + slideId;
    imageSlidersCarousel = tns({
      container: selectorName,
      startIndex: 0,
      mouseDrag: true,
      speed: 200,
      loop: true,
      controls: false,
      nav: false,
      items: 1,
    });
    const carouselPrev = document.getElementById(slideId + "-prev");
    const carouselNext = document.getElementById(slideId + "-next");
    if (carouselPrev && carouselNext) {
      carouselPrev.addEventListener("click", () =>
        imageSlidersCarousel.goTo("prev")
      );
      carouselNext.addEventListener("click", () =>
        imageSlidersCarousel.goTo("next")
      );
    }
  });
}


// Set discover carousel
let exhibitFeaturedCarousel;
const featuredCarousel = document.getElementById("featured__carousel");
if (featuredCarousel) {
  exhibitFeaturedCarousel = tns({
    container: "#featured__carousel",
    startIndex: 0,
    mouseDrag: true,
    speed: 200,
    loop: true,
    gutter: 20,
    controls: false,
    nav: false,
    responsive: {
      0: {
        edgePadding: 45,
        items: 1,
      },
      480: {
        edgePadding: 0,
        items: 3,
      },
      768: {
        items: 4,
        center: false
      },
    },
  });
  // // setup slider overlay links
  // initOverlayLinks();
  // set initial index
  setCarouselActiveClass(exhibitFeaturedCarousel);
  // se index on change
  exhibitFeaturedCarousel.events.on("indexChanged", () => {
    setCarouselActiveClass(exhibitFeaturedCarousel);
  });

  // const featuredCarouselPrev = document.getElementById(
  //   "discover__carousel-prev"
  // );
  // const featuredCarouselNext = document.getElementById(
  //   "discover__carousel-next"
  // );
  // if (featuredCarouselPrev && featuredCarouselNext) {
  //   featuredCarouselPrev.addEventListener("click", () =>
  //     exhibitFeaturedCarousel.goTo("prev")
  //   );
  //   featuredCarouselNext.addEventListener("click", () =>
  //     exhibitFeaturedCarousel.goTo("next")
  //   );
  // }
}